module.exports = __webpack_public_path__ + "img/cube.a447b77f.jpg";